export default __webpack_public_path__ + "static/media/024-speed limit.1e362fee.png";